import React from "react";
import SectionBanner from "../components/SectionBanner/SectionBanner";
import Form from "../components/Form/Form";

const Contact = () => {
  return (
    <div>
      <SectionBanner heading="CONTACT" subHeading="Let's have a chat" />
      <Form />
    </div>
  );
};

export default Contact;
